/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Profile_Activity_RarityInputs */

const id_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% kelangkaan`)
};

const ms_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% kecelaruan`)
};

const da_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% sjældenhed`)
};

const de_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% Seltenheit`)
};

const en_us2_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% rarity`)
};

const es_es2_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% rareza`)
};

const es_mx2_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% rareza`)
};

const fil_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% rarity`)
};

const fr_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rareté ${i?.value}%`)
};

const it_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% rarità`)
};

const hu_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% ritkaság`)
};

const nl_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% zeldzaamheid`)
};

const no_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% sjeldenhet`)
};

const pl_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% rzadkości`)
};

const pt_br2_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% raridade`)
};

const pt_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% raridade`)
};

const ro_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% raritate`)
};

const fi_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% harvinaisuus`)
};

const sv_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% sällsynthet`)
};

const vi_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% độ hiếm`)
};

const tr_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`%${i?.value} nadirlik`)
};

const cs_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% vzácnost`)
};

const bg_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% рядкост`)
};

const ru_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% редкость`)
};

const uk_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% рідкість`)
};

const ar_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ندرة ${i?.value}%`)
};

const hi_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}% दुर्लभता`)
};

const th_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ความหายาก ${i?.value}%`)
};

const ja_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`レアリティ ${i?.value}%`)
};

const zh_cn2_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`稀有度 ${i?.value}%`)
};

const zh_hant1_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`稀有度 ${i?.value}%`)
};

const ko_profile_activity_rarity = /** @type {(inputs: Profile_Activity_RarityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`희귀도 ${i?.value}%`)
};

/**
* | output |
* | --- |
* | "{value}% rarity" |
*
* @param {Profile_Activity_RarityInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_activity_rarity = /** @type {((inputs: Profile_Activity_RarityInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Activity_RarityInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_activity_rarity(inputs)
	if (locale === "ms") return ms_profile_activity_rarity(inputs)
	if (locale === "da") return da_profile_activity_rarity(inputs)
	if (locale === "de") return de_profile_activity_rarity(inputs)
	if (locale === "en-US") return en_us2_profile_activity_rarity(inputs)
	if (locale === "es-ES") return es_es2_profile_activity_rarity(inputs)
	if (locale === "es-MX") return es_mx2_profile_activity_rarity(inputs)
	if (locale === "fil") return fil_profile_activity_rarity(inputs)
	if (locale === "fr") return fr_profile_activity_rarity(inputs)
	if (locale === "it") return it_profile_activity_rarity(inputs)
	if (locale === "hu") return hu_profile_activity_rarity(inputs)
	if (locale === "nl") return nl_profile_activity_rarity(inputs)
	if (locale === "no") return no_profile_activity_rarity(inputs)
	if (locale === "pl") return pl_profile_activity_rarity(inputs)
	if (locale === "pt-BR") return pt_br2_profile_activity_rarity(inputs)
	if (locale === "pt") return pt_profile_activity_rarity(inputs)
	if (locale === "ro") return ro_profile_activity_rarity(inputs)
	if (locale === "fi") return fi_profile_activity_rarity(inputs)
	if (locale === "sv") return sv_profile_activity_rarity(inputs)
	if (locale === "vi") return vi_profile_activity_rarity(inputs)
	if (locale === "tr") return tr_profile_activity_rarity(inputs)
	if (locale === "cs") return cs_profile_activity_rarity(inputs)
	if (locale === "bg") return bg_profile_activity_rarity(inputs)
	if (locale === "ru") return ru_profile_activity_rarity(inputs)
	if (locale === "uk") return uk_profile_activity_rarity(inputs)
	if (locale === "ar") return ar_profile_activity_rarity(inputs)
	if (locale === "hi") return hi_profile_activity_rarity(inputs)
	if (locale === "th") return th_profile_activity_rarity(inputs)
	if (locale === "ja") return ja_profile_activity_rarity(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_activity_rarity(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_activity_rarity(inputs)
	return ko_profile_activity_rarity(inputs)
});
export { profile_activity_rarity as "profile.activity.rarity" }